export default __webpack_public_path__ + "static/SRUS RT220 - Especification Del Producto y Datos Técnicos-f01b604f9b717a91a3aa3e397e328f1a.pdf";